import {
  ADDED,
  ADDEDPRODUCT,
  DECREMENT,
  INCREMENT,
  REMOVE,
} from "./actionTypes";

import { initialState } from "./intialState";

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case ADDEDPRODUCT:
      return {
        ...state,
        products: [...state.products, action.payload],
      };
    case ADDED:
      const cartitems = state.cart.find(
        (item) => item.id === action.payload.id
      );
      if (cartitems) {
        return {
          ...state,
          products: state.products.map((product) => {
            if (product.id === action.payload.id) {
              product.Quantity--;
            }
            return product;
          }),
          cart: state.cart.map((item) => {
            if (item.id === action.payload.id) {
              item.Quantity++;
            }
            return item;
          }),
        };
      } else {
        return {
          ...state,
          products: state.products.map((product) => {
            if (product.id === action.payload.id) {
              product.Quantity--;
            }
            return product;
          }),
          cart: [...state.cart, action.payload],
        };
      }
    case REMOVE:
      return {
        ...state,
        cart: state.cart.filter((item) => item.id !== action.payload),
        products: state.products.map((product) => {
          if (product.id === action.payload) {
            product.Quantity = product.allqty;
          }
          return product;
        }),
      };
    case INCREMENT:
      return {
        ...state,
        products: state.products.map((product) => {
          if (product.id === action.payload) {
            product.Quantity === 0
              ? (product.Quantity = 0)
              : product.Quantity--;
          }
          return product;
        }),
        cart: state.cart.map((item) => {
          if (item.id === action.payload) {
            item.allqty !== item.Quantity
              ? item.Quantity++
              : (item.Quantity = item.allqty);
          }
          return item;
        }),
      };
    case DECREMENT:
      return {
        ...state,
        products: state.products.map((product) => {
          if (product.id === action.payload) {
            product.Quantity === product.allqty - 1
              ? (product.Quantity = product.allqty - 1)
              : product.Quantity++;
          }
          return product;
        }),
        cart: state.cart.map((item) => {
          if (item.id === action.payload) {
            item.Quantity === 1 ? (item.Quantity = 1) : item.Quantity--;
          }
          return item;
        }),
      };
    default:
      return state;
  }
};

export default reducers;
